import { Button } from "bootstrap";
import React from "react";
import { Col, Container, Image, Row } from "react-bootstrap";
import { BsArrowRight } from "react-icons/bs";

export const SectionThree = () => {
  return (
    <>
      <Container fluid className="ATS">
        <Container>
          <div className="webkit">
            <h2
              className="text-5xl font-extrabold"
              style={{ color: "#00803E" }}
            >
              Airport Transfer Services
            </h2>
            <h3 className="text-sm font-bold text-white">
              Book With An Approved, Fixed-price, And Reliable Taxi Company To
              Pay Online <br />
              Securely And You Can Book Months In Advance.
            </h3>
          </div>
          <Row>
            <Col lg="12" className="py-2">
              <Image src={require("../../assets/airoplane.png")} />
            </Col>
            <Col lg="6">
              <div className="p-2">
                <Image
                  style={{ width: "80%" }}
                  src={require("../../assets/brvnews.png")}
                />
              </div>
            </Col>
            <Col lg="6">
              <div className="p-2" style={{ textAlign: "-webkit-right" }}>
                <div
                  style={{
                    background: "rgb(255 255 255 / 26%)",
                    padding: "10px",
                    textAlign: "left",
                    width: "84%",
                  }}
                >
                  <p className="text-sm text-white">
                    Book With An Approved, Fixed-price, And Reliable Taxi
                    Company To Pay Online Securely And You Can Book Months In
                    Advance.
                  </p>
                  <button className="text-white rounded-lg bgGreen py-2 px-5 d-flex gap-2 align-items-center my-3">
                    Book Now <BsArrowRight />
                  </button>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </Container>
    </>
  );
};
